export default __webpack_public_path__ + "static/media/icon-visibility-off-color-primary.bc8958e0.svg";